import { ValueOf } from './util';

/** 端末種別のenum */
export const ETerminalType = {
  MERCHANT: '加盟店アプリ',
  POS_TERMINAL: 'POS端末',
  PAYMENT_TERMINAL: '決済端末',
  PAPER_QR: '紙QR',
  CHARGE: 'チャージ機',
  UNSELECTED: '-',
} as const;

export type TerminalTypeKey = keyof typeof ETerminalType;
export type TerminalTypeValue = ValueOf<typeof ETerminalType>;

export const terminalTypeKeys = Object.keys(ETerminalType) as (TerminalTypeKey[]);

/** v-select用items */
export const terminalTypeItems = terminalTypeKeys
  .map((key) => ({
    // https://infcuriondigital.slack.com/archives/C032VGBV5N3/p1703055885700549?thread_ts=1703051886.198039&cid=C032VGBV5N3
    title: key === 'UNSELECTED' ? '未選択' : ETerminalType[key],
    value: key,
  }));
